import { render, staticRenderFns } from "./DictionaryTitle.vue?vue&type=template&id=602dbd9a&scoped=true&"
import script from "./DictionaryTitle.vue?vue&type=script&lang=js&"
export * from "./DictionaryTitle.vue?vue&type=script&lang=js&"
import style0 from "./DictionaryTitle.vue?vue&type=style&index=0&id=602dbd9a&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "602dbd9a",
  null
  
)

export default component.exports